/**
 * TVG-315: an admin-editable setting.
 */
export interface Setting {
  id: number;
  key: string;
  label: string;
  description: string | null;
  value: string | null;
  is_public: boolean;
  last_changed_at: string | null;
  last_changed_by: { id: number; name: string } | null;
}

/** Map of setting key to value, as returned by GET /api/settings/public. */
export type SettingMap = Record<string, string | null>;

/**
 * Keys referenced from code. Keep in step with config/settings.php.
 */
export const SETTING_KEYS = {
  textPermissionOptInWording: 'text-permission-opt-in-wording',
} as const;
